<template>
  <form @submit="submit" class="item-editor-form">
    <fg-input
      v-model="form.vehicleLabel"
      :label="$t('vehicle.label')"
      :disabled="action == 'item'"
    ></fg-input>
    <fg-input
      v-model="form.computerLabel"
      :label="$t('vehicle.computer')"
    ></fg-input>
    <label for="organization">{{ $t('vehicle.organisation') }}</label>
    <OrganisationSelect v-model="form.organization" id="organization" />

    <div v-if="action == 'item'">
      <div v-for="ovf in localOrganizationFeatures" :key="ovf.id">
        <div v-if="ovf.type === 'BOOLEAN'" class="vehicle-feature-label">
          <label>{{ $t(ovf.descriptionId) }}</label>
          <b-form-checkbox
            value="true"
            unchecked-value="false"
            v-model="form.features[ovf.name]"
            class="vehicle-input"
          />
        </div>
        <div v-else-if="ovf.type === 'SELECT'">
          <label>{{ $t(ovf.descriptionId) }}</label>
          <vSelect
            :options="ovf.validValues"
            v-model="form.features[ovf.name]"
          />
        </div>
        <div v-else-if="ovf.name === 'SIP_CLIENT_ID'">
          <label>{{ $t(ovf.descriptionId) }}</label>
          <b-input-group>
            <b-form-input v-model="form.features[ovf.name]" />
            <b-input-group-append is-text>
              <b-icon
                v-if="!isSipIdInPhonebook"
                icon="exclamation-triangle"
                :title="$t('vehicles.feature.sip_configuration_missing')"
              />
            </b-input-group-append>
          </b-input-group>
        </div>
        <div v-else>
          <fg-input
            :label="$t(ovf.descriptionId)"
            v-model="form.features[ovf.name]"
          />
        </div>
      </div>
    </div>

    <FormButtons
      @submit="submit"
      :submit="$UIPrivilegeU('realtime/vehicles')"
      :reset="false"
      @remove="remove"
      :remove="action == 'item' && $UIPrivilegeD('realtime/vehicles')"
      :itemid="this.form.vehicleLabel"
      :modalid="'vehicleEditModal'"
      :disableSubmit="loading"
      :disableRemove="loading"
    />

    <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
  </form>
</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'
import OrganisationSelect from '@/components/Timetable/OrganisationSelect'
import realtime from '@/store/realtime/realtime'
import phone from '@/store/dispatching/phone'
import vSelect from 'vue-select'

export default {
  components: {
    FormButtons,
    OrganisationSelect,
    vSelect,
  },
  props: {
    item: { default: null },
    action: { default: 'new' },
  },
  data: function () {
    return {
      ok: false,
      error: false,
      loading: false,
      infoType: 'save',
      localOrganizationFeatures: [],
      form: {
        vehicleId: null,
        vehicleLabel: null,
        computerLabel: null,
        vehicleType: null,
        organization: null, // organizationId
        features: {},
        addedBy: null,
        added: null,
        editedBy: null,
        edited: null,
      },
      defaultFormData: {
        vehicleId: null,
        vehicleLabel: null,
        computerLabel: null,
        vehicleType: null,
        organization: null, // organizationId
        features: {},
        addedBy: null,
        added: null,
        editedBy: null,
        edited: null,
      },
    }
  },
  created() {
    if (!this.$store.state.realtime) {
      this.$store.registerModule('realtime', realtime)
    }
    if (!this.$store.state.phone) {
      this.$store.registerModule('phone', phone)
    }
    if (this.item?.organization) {
      this.getOrganizationVehicleFeatures(this.item.organization)
    }
    this.copyItemData()
  },
  computed: {
    isSipIdInPhonebook() {
      return !(
        this.form.features.SIP_CLIENT_ID &&
        !this.$store.state.phone.phonebook[this.form.features.SIP_CLIENT_ID]
      )
    },
  },
  watch: {
    item: function (item) {
      if (item) {
        this.getOrganizationVehicleFeatures(item.organization)
        this.copyItemData()
      } else {
        this.form = Object.assign({}, this.defaultFormData)
      }
      this.ok = this.error = this.loading = false
    },
    'form.organization': function (newOrganizationId) {
      this.getOrganizationVehicleFeatures(newOrganizationId)
    },
  },
  methods: {
    getOrganizationVehicleFeatures(organizationId) {
      this.$store
        .dispatch('realtime/fetchOrganizationVehicleFeatures', organizationId)
        .then((data) => {
          this.localOrganizationFeatures = data
        })
        .catch(() => {
          this.localOrganizationFeatures = []
        })
    },
    submit(event) {
      if (event) event.preventDefault()

      this.ok = this.error = false
      this.infoType = 'save'
      this.loading = true

      setTimeout(() => {
        this.$store
          .dispatch('realtime/updateVehicle', this.form)
          .then((response) => {
            this.ok = response.data.errorCode == 0
            this.error = !this.ok
          })
          .catch(() => {
            this.error = true
          })
          .finally(() => {
            this.loading = false
            //this.$emit('updateItem', this.item);
          })
      }, 1000)
    },
    reset(event) {
      event.preventDefault()
      this.item = null
      this.form = Object.assign({}, this.defaultFormData)
    },
    remove() {
      this.infoType = 'delete'
      this.loading = true

      setTimeout(() => {
        this.$store
          .dispatch('realtime/deleteVehicle', this.item.vehicleId)
          .then((response) => {
            this.ok = response.data.errorCode == 0
            this.error = !this.ok
          })
          .catch(() => {
            this.error = true
          })
          .finally(() => {
            this.loading = false
          })
      }, 1000)
    },
    copyItemData() {
      if (this.item) {
        this.form = JSON.parse(JSON.stringify(this.item))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.vehicle-feature-label {
  display: flex;
  flex-direction: row;
  label {
    width: 100%;
  }
}
</style>
